import dynamic from 'next/dynamic'
import { ICategory } from '../../interfaces/ICategory'
import { ICourse } from '../../interfaces/ICourse'
import { IPaymentPlans } from '../../interfaces/IPaymentsPlan'
import { ISchool } from '../../interfaces/school.interface'
import LoadingSkeletonComponent from '../LoadingComponents/LoadingSkeletonComponent'
import React from 'react'

const BrmcPageView = dynamic(() => import('./BrmcLandingPage/BrmcPageView'), {
  ssr: true,
  loading: () => (
    <div>
      <LoadingSkeletonComponent />
    </div>
  ),
})

const DemiLandingPage2 = dynamic(
  () => import('./DemiLandingPage2/DemiPageView'),
  {
    ssr: true,
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

const OrangeVfxView = dynamic(() => import('./orangeVfx/OrangeVfxView'), {
  ssr: true,
  loading: () => (
    <div>
      <LoadingSkeletonComponent />
    </div>
  ),
})

// const MarvelPageView = dynamic(() => import('./Marvel/MarvelPageView'), {
//   ssr: true,
//   loading: () => (
//     <div>
//       <LoadingSkeletonComponent />
//     </div>
//   ),
// })

const NitoonsPageView = dynamic(() => import('./Nitoons/NitoonsPageView'), {
  ssr: true,
  loading: () => (
    <div>
      <LoadingSkeletonComponent />
    </div>
  ),
})

const DefaultHomepage = dynamic(
  () => import('./DefaultHomepage/SchoolHomePage'),
  {
    ssr: true,
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

interface IProps {
  openCourseIdDetails?: string
  schoolDetails: ISchool
  courses: ICourse[]
  payment_plans: IPaymentPlans
  categories: ICategory[]
  ignoreCustomLandingPage?: boolean
}

const SchoolHomepage = (props: IProps) => {
  const { schoolDetails } = props
  if (!schoolDetails) return <div />

  // if (
  //   schoolDetails?.craftjs_landing_page_id &&
  //   schoolDetails?.craftjs_landing_page_data &&
  //   props.craftjsLandingPageData &&
  //   !props.ignoreCustomLandingPage
  // ) {
  //   return (
  //     <div>
  //       <LandingPageDetailsView
  //         landingPageData={props.craftjsLandingPageData}
  //         slug={schoolDetails?.craftjs_landing_page_data?.page_slug}
  //         schoolDetails={props.schoolDetails}
  //       />
  //     </div>
  //   );
  // }

  if (
    schoolDetails?.homepage_template_id === 'template001' &&
    !props.ignoreCustomLandingPage
  ) {
    return (
      <>
        <OrangeVfxView {...props} />
      </>
    )
  }

  // if (
  //   schoolDetails?.homepage_template_id === "demi_1" &&
  //   !props.ignoreCustomLandingPage
  // ) {
  //   return (
  //     <>
  //       <DemiLandingPageView {...props} />
  //     </>
  //   );
  // }

  if (
    schoolDetails?.homepage_template_id === 'demi_2' &&
    !props.ignoreCustomLandingPage
  ) {
    return (
      <>
        <DemiLandingPage2 {...props} />
      </>
    )
  }

  if (
    schoolDetails?.homepage_template_id === 'marvel' &&
    !props.ignoreCustomLandingPage
  ) {
    return (
      <>
        <NitoonsPageView {...props} />
      </>
    )
  }

  if (
    schoolDetails?.homepage_template_id === 'nitoons' &&
    !props.ignoreCustomLandingPage
  ) {
    return (
      <>
        <NitoonsPageView {...props} />
      </>
    )
  }

  if (
    schoolDetails?.homepage_template_id === 'brmc' &&
    !props.ignoreCustomLandingPage
  ) {
    return <BrmcPageView {...props} />
  }

  return (
    <>
      <DefaultHomepage {...props} />
    </>
  )
}

export default SchoolHomepage
